import { Select, SelectItem, Skeleton } from "@heroui/react";
import { Icon } from "@iconify/react";

import { langOptions } from "@onesolution/constants";
import { useLanguage } from "@onesolution/hooks";
import { useIsClient } from "usehooks-ts";

export default function LanguageSelect({ collapsed }: { collapsed?: boolean }) {
	const isClient = useIsClient();
	const { lang, setLanguage } = useLanguage();

	return lang && isClient ? (
		<Select
			className={collapsed ? "w-fit" : "max-w-xs"}
			aria-label="language switcher"
			selectedKeys={[lang]}
			variant="flat"
			classNames={{
				trigger: `bg-transparent hover:bg-auto! shadow-none! cursor-pointer ${collapsed ? "" : "pl-5"}`,
				selectorIcon: "hidden",
				innerWrapper: "w-full",
				value: `text-foreground-500! ml-1 ${collapsed ? "hidden" : ""}`,
			}}
			startContent={<Icon className="size-5" icon={`circle-flags:${lang}`} />}
		>
			{langOptions.map(({ key, name }) => (
				<SelectItem
					key={key}
					className={collapsed ? "pl-1" : ""}
					startContent={
						<Icon className="min-w-5 min-h-5" icon={`circle-flags:${key}`} />
					}
					classNames={{
						title: "flex flex-row gap-4 items-center",
					}}
					onClick={() => setLanguage(key)}
					textValue={name}
				>
					{collapsed ? "" : name}
				</SelectItem>
			))}
		</Select>
	) : (
		<Skeleton
			className={`rounded-lg ${collapsed ? "w-full h-1/2" : "w-1/2 h-full ml-4 mb-4"}`}
		/>
	);
}
